/* eslint no-underscore-dangle: 0 */
import React, { useState } from 'react'

import { useHistory } from 'react-router-dom'

import { I18n } from 'aws-amplify'

import { useAuth } from '../../../../../presentation/contexts/auth'
import ForgotPassword from '../../../../../presentation/pages/common/amplify/forgot-passwoord'

import {
  makeForgotPassword,
  makeForgotPasswordContractor,
} from '../../../../usecases/forgot-password/remote-forgot-password-factory'

import { HelperAmplify } from '../../../../../presentation/helpers'
import { RoutesEnum } from '../../../../../presentation/enums'

// import { Container } from './styles'

// eslint-disable-next-line no-shadow
enum FormType {
  REQUEST_CODE = 'REQUEST_CODE',
  RESET_PASSWORD = 'RESET_PASSWORD',
  SEND_CODE = 'SEND_CODE',
}

const MakeForgotPassword = () => {
  document.title = 'BuscarMédicos - Esqueci minha senha'

  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [formType, setFormType] = useState<FormType>(FormType.REQUEST_CODE)
  const [valueDisplay, setValueDisplay] = useState('none')
  const [contador, setContador] = useState(5)
  const { setEmailToRecoveryPassword } = useAuth()

  const history = useHistory()

  const changeForm = (param: FormType) => {
    setFormType(param)
  }

  const dataFormRequest = [
    {
      items: [
        {
          name: 'email',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          type: 'email',
          title: 'E-mail',
          label: 'E-mail',
          required: true,
          validations: 'emailRequired',
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Receber código',
          submittingText: 'Enviando...',
        },
      ],
    },
  ]

  const dataFormSendCode = [
    {
      items: [
        {
          name: 'code',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          type: 'number',
          title: 'Insira o códigoo',
          label: 'Insira o códigoo',
          required: true,
        },
        {
          name: 'email',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          type: 'email',
          title: 'Confirmar E-mail',
          label: 'Confirmar E-mail',
          required: true,
          validations: 'emailRequired',
        },
        {
          name: 'password',
          component: 'InputPassword',
          value: '',
          placeholder: 'Digite aqui',
          type: 'password',
          title: 'Nova senha',
          label: 'Nova senha',
          required: true,
        },
        {
          name: 'button1',
          component: 'Button',
          title: `${contador >= 0 ? `${contador}` : 'Salvar nova senha'}`,
          submittingText: 'Enviando...',
        },
      ],
    },
  ]

  const RequestCode = async (values: any): Promise<void> => {
    const { email } = values

    try {
      let forgotPasswordFunction
      const userType = localStorage.getItem('userType')

      if (userType === 'CONTRATANTE') {
        forgotPasswordFunction = makeForgotPasswordContractor
      } else {
        forgotPasswordFunction = makeForgotPassword
      }

      await forgotPasswordFunction().post(values.email)
      setEmailToRecoveryPassword(email)
      changeForm(FormType.SEND_CODE)

      const interval = setInterval(() => {
        setContador((count) => count - 1)
        if (contador === 1) {
          setValueDisplay('block')
          clearInterval(interval)
          console.log(valueDisplay)
        }
      }, 1000)
    } catch (error: any) {
      const msg = I18n.get(error.name)
      setErrorMessage(msg)
    }
  }

  const SendCodeAndNewPassword = async (values: any) => {
    const { email, code, password } = values
    try {
      await HelperAmplify.recoveryPassword(email, code, password)
      history.push(RoutesEnum.SIGNIN)
    } catch (error) {
      console.error('Erro ao recuperar senha', error)
    }
  }

  let formToRender
  let handleSubmit

  switch (formType) {
    case FormType.REQUEST_CODE:
      formToRender = dataFormRequest
      handleSubmit = RequestCode
      break
    case FormType.SEND_CODE:
      formToRender = dataFormSendCode
      handleSubmit = SendCodeAndNewPassword
      break
    default:
      formToRender = dataFormRequest
      handleSubmit = RequestCode
  }

  return (
    <ForgotPassword
      dataForm={formToRender}
      onSubmit={handleSubmit}
      errorMessage={errorMessage}
    />
  )
}

export default MakeForgotPassword
